exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".temp-wrapper[data-v-0bce6a64]{border:1px solid #eee;border-bottom:0}.temp-wrapper[data-v-0bce6a64]:last-child{border:1px solid #eee}.desc[data-v-0bce6a64]{font-size:.8rem;margin-top:4px;color:#787878}", ""]);

// exports
